(function() {
    'use strict';

    angular.module( APP_ID )
        .controller( 'DegreesController', [ '$scope', '$controller', 'ContentSwitchingService', 'SubpagesService', 'LoggerFactory', 'SelectablesService', 'MetaService', 'Utils', 'CONFIG', DegreesController ]);


    /**
     * Downloads and prepares data for a specific degree.
     *
     * @param {ng.IScope} $scope
     * @param {ng.IControllerService} $controller
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {SubpagesService} SubpagesService
     * @param {LoggerFactory} LoggerFactory
     * @param {SelectablesService} SelectablesService
     * @param {MetaService} MetaService
     * @param {Utils} Utils
     * @param {Object} CONFIG
     */
    function DegreesController(
        $scope,
        $controller,
        ContentSwitchingService,
        SubpagesService,
        LoggerFactory,
        SelectablesService,
        MetaService,
        Utils,
        CONFIG
    ){

        /** @type {angular.IController} */
        var vm    = this;





        /* ===== PRIVATE MEMBERS ============================================ */



        /** @constant */
        var RESPONSE_ATTRIBUTE_INTERNATIONAL_API = 'internationalApiCode';


        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'DegreesController' );

        /** @type {BaseController} */
        var ctrl   = $controller( 'BasePageController', { 'vm': vm, 'logger': logger } );





        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        /** @type {Object} */
        vm.dynamicBlocksSettings = undefined;





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        function init(){
            overrideBaseController();
            ctrl.activate(); // Initialise and execute parental controller

            setCustomMetadataFormat();

            SubpagesService.setSubpagesFromChildren();
        };

        /** Run right after all the bindings are ready! */
        vm.$onInit = init;


        /** @destructor */
        vm.$onDestroy = function() {
            SelectablesService.deregisterUrlSync();
        }





        /* ===== PRIVATE FUNCTIONS ========================================== */


        /**
         * Formats metadata's description and title specifically for degrees.
          */
        function setCustomMetadataFormat() {
            // Check `metadata.service.js` to get the default format and see all available options
            var DESCRIPTION_TEMPLATE    = "{{ ContentSwitchingService.isInternational() ? 'International student? ' : '' }}{{ descriptionStructure.subpage }}{{ descriptionStructure.page | prepend:' ' }}{{ descriptionStructure.site | prepend:' ' }}{{ ContentSwitchingService.isInternational() ? ', New Zealand' : '' }}{{ descriptionStructure.suffix | prepend:'. ' }}";

            MetaService.setDescriptionTemplate( DESCRIPTION_TEMPLATE );
        }


        /**
         * Overrides parental's controller behaviour and attaches hooks.
         *
         * Note: MUST BE called BEFORE the parental controller is activated!
         */
        function overrideBaseController() {
            ctrl.contentRequestParams = {
                viewUrl: vm.$transition$.params()[ CONFIG.PARAMS.DEGREE_ID ],
                urlPath: CONFIG.API.CMS.PATHS.DEGREES
            };

            ctrl.requiredContentAttributes.push( 'pages', 'metadata' ); // Validates that following content attributes do exist in a response

            ctrl.postProcessResponse = postProcessResponse;
        }


        /**
         * Is triggered AFTER getting a response from CMS, validating all
         * required attributes and processing part of the response.
         *
         * @param {Object} responseObject
         */
        function postProcessResponse( responseObject ){
            if ( vm.metadata.hasOwnProperty( RESPONSE_ATTRIBUTE_INTERNATIONAL_API )){
                ContentSwitchingService.setProgrammeCode( vm.metadata[ RESPONSE_ATTRIBUTE_INTERNATIONAL_API ] );
            } else {
                logger.error( "International API code for degree `%s` is missing. Please, make sure `metadata.%s` is in place.", vm.metadata.fullName, RESPONSE_ATTRIBUTE_INTERNATIONAL_API );
            }

            if ( vm.metadata.hasOwnProperty( 'bannerDescription' ) ) {
                vm.sharedContent.abstract = vm.metadata.bannerDescription;
            }

            Utils.mapSubpagesBlocksToContent( responseObject.pages, vm.content );

            // Number of selectors available
            var selectorsCount = ( vm.metadata.subqualsAllowed === 'null' ) ? 0 : vm.metadata.subqualsAllowed;

            // Majors
            if ( responseObject.majors ){
                var majorsObject = {
                    majors: responseObject.majors,
                    custom: ( responseObject.customContent && angular.isDefined( responseObject.customContent.majorsLists ) ) ? responseObject.customContent : null
                };

                // Add majors to the searchable metadata
                if ( responseObject.hasOwnProperty( 'majors' ) && responseObject.majors.length > 0 ){
                    MetaService.searchAttributes.push({
                        name:  'majors',
                        value: getDelimitedStringFromMajors( responseObject.majors ),
                    });
                }

                SelectablesService.createSelectableMajors( 'degreeMajors', majorsObject, selectorsCount );
            } else {
                logger.error( "No majors were retrieved from the CMS.", responseObject.major );
            }

            saveInfoToCookie();
            setPostWatchers();
        }


        /**
         * Sets up post-processing watchers tracking changes on Majors.
         */
        function setPostWatchers() {
            /** @type {Selectables} */
            var majorSelectables    = SelectablesService.getSelectablesById( 'degreeMajors' );
            var lastVisitedPage     = ContentSwitchingService.userSettings.lastVisitedPage;

            var TEMPLATE_META_MAJORLESS = vm.metadata.fullName + ' (' + vm.metadata.code + ')';

            $scope.$watch( function() {
                return majorSelectables.model.primaryItem;
            }, function( newPrimaryItem ) {

                // Adding only single major into the title is OK, because the `otherMajor` query is ignored by Google as a filtering query (see GWT's query settings)
                var metaTemplateBase = TEMPLATE_META_MAJORLESS + ( newPrimaryItem ? ', ' + newPrimaryItem.title + ' major' : '' );

                MetaService.updateTitleStructure({
                    page: metaTemplateBase + ( !newPrimaryItem ? ' degree' : '' )
                });

                MetaService.updateDescriptionStructure({
                    page: metaTemplateBase
                });

                if ( newPrimaryItem ) {
                    lastVisitedPage.degree[ 'majorTitle' ] = newPrimaryItem.title;
                } else if ( lastVisitedPage.degree.hasOwnProperty( 'majorTitle' ) ) {
                    delete lastVisitedPage.degree.majorTitle;
                }

                // Save updated user information to the cookies!
                if ( ContentSwitchingService.isCookieAvailable() ) ContentSwitchingService.saveSettingsToCookie();
            });

            $scope.$watch( function() {
                return majorSelectables.model.secondaryItem;
            }, function( newSecondaryItem ) {
                if ( newSecondaryItem ) {
                    lastVisitedPage.degree[ 'otherMajorTitle' ] = newSecondaryItem.title;
                } else if ( lastVisitedPage.degree.hasOwnProperty( 'otherMajorTitle' ) ) {
                    delete lastVisitedPage.degree.otherMajorTitle;
                }

                // Save updated user information to the cookies!
                if ( ContentSwitchingService.isCookieAvailable() ) ContentSwitchingService.saveSettingsToCookie();
            });
        }


        function getDelimitedStringFromMajors( majorsList ) {
            var delimitedString = '';

            majorsList.forEach( function( major ) {
                delimitedString += major.name + ';';
            });

            return delimitedString;
        }


        /**
         * Saves information about current degree into a cookie, if it was
         * already created by the `ContentSwitchingService`.
         *
         * TODO: Make saving more efficient and transactional (instead of
         * calling `ContentSwitchingService.saveSettingsToCookie()` twice,
         * call it once).
         */
        function saveInfoToCookie() {
            // TODO: Refactor and simplify
            var lastVisitedPage = ContentSwitchingService.userSettings.lastVisitedPage;

            if ( !lastVisitedPage.hasOwnProperty( 'degree' ) ) lastVisitedPage[ 'degree' ] = {};

            if ( vm.metadata.hasOwnProperty( RESPONSE_ATTRIBUTE_INTERNATIONAL_API ) ){
                lastVisitedPage.degree[ 'apiId' ]   = vm.metadata[ RESPONSE_ATTRIBUTE_INTERNATIONAL_API ];

                if ( lastVisitedPage.degree.hasOwnProperty( 'webPath' ) ) delete lastVisitedPage.degree.webPath;
            } else {
                lastVisitedPage.degree[ 'webPath' ] = vm.$transition$.params()[ CONFIG.PARAMS.DEGREE_ID ];

                if ( lastVisitedPage.degree.hasOwnProperty( 'apiId' ) ) delete lastVisitedPage.degree.apiId;
            }

            // Save updated user information to the cookies!
            if ( ContentSwitchingService.isCookieAvailable() ) ContentSwitchingService.saveSettingsToCookie();
        }


    }
})();
